import axios from 'axios'
import config from '../config/config'
// import store from '../store/index'
import { toFormData } from "../utils/form"
import { encryptParam, Decrypt } from '../utils/parsingEncrypt'

const request = axios.create({
  baseURL: config.host,
  timeout: config.timeout
})

/**
 *    request 攔截
 */
request.interceptors.request.use(function (config) {
  const token = localStorage.getItem('QQC_TOKEN')
  config.headers = {
    app: 3,
    platform: 5,
    token: token || '',
    // 落地页统计
    isldy: 1
   
  }
  // 待加密字符
  let dataSin = {};
  let headerSin = {};
  if (config.method === 'post') {
    dataSin = config.data;
    config.data = toFormData({
      d: encryptParam(dataSin)
    })
  }else if(config.method === 'get') {
    // 设置加密
    dataSin = config.params;
    config.params = {
      d: encryptParam(dataSin)
    }
  }
  // 加密并生成排序
  headerSin = config.headers;
  config.headers = {
    d: encryptParam(headerSin),
  }
  return config
}, function (error) {
  return Promise.reject(error);
});

/**
 *    response 攔截
 */

request.interceptors.response.use(function (response) {
   // 解密返回数据
   const parsing = {...response}
   parsing.data = JSON.parse(Decrypt(response.data.d))
  //  console.log(' parsing.data',  parsing.data)
  console.log(response.config.url)
  console.log(parsing.data)
   return parsing.data;
}, function (error) {
  return Promise.reject(error);
});

export default request
